<template>
  <v-badge
    overlap
    :class="currentlyViewedChallenge.isFacilitator || currentlyViewedChallenge.isCofacilitator ? 'thought-badge drag-drop' : 'thought-badge'"
    :data-thoughtid=thought.uuid
    data-thoughttype="publicThought"
    :color="color"
    :id="'thought-'+thought.uuid"
  >
    <template v-slot:badge>
      <span>{{ thought.pins.length }}</span>
    </template>
    <v-card
      width="250"
      class="public-thought"
    >
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title
            style="white-space: normal"
          >
          {{ thought.content }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-card>
  </v-badge>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'PublicThought',
  props: ['thought'],

  data: () => ({
    isHoveringOverPin: false
  }),

  mounted () {
    const thoughtBadgeWrapper = document.querySelector(`#thought-${this.thought.uuid}`)
    const thoughtBadge = thoughtBadgeWrapper.querySelector('.v-badge__badge')
    thoughtBadge.addEventListener('mouseenter', () => { this.isHoveringOverPin = true })
    thoughtBadge.addEventListener('mouseleave', () => { this.isHoveringOverPin = false })
    thoughtBadge.addEventListener('click', () => { this.toggleBadgeClick() })
  },

  computed: {
    ...mapState({
      userId: state => state.auth.userInfo.account.uuid,
      currentlyViewedChallenge: state => state.challenge.currentlyViewedChallenge
    }),

    isPinned () {
      return this.thought.pins.includes(this.userId)
    },

    color () {
      return (this.isHoveringOverPin || this.isPinned) ? 'red' : 'grey'
    }
  },

  methods: {
    ...mapActions('canvas', ['requestToggleThoughtPin']),

    toggleBadgeClick () {
      this.requestToggleThoughtPin(this.thought)
    },

    handlePinHover () {
      console.log('hover')
    }
  }
}
</script>

<style lang="sass" scoped>
  .thought-badge
    touch-action: none
    margin: 1em
    cursor: pointer !important

  .public-thought
    background-image: linear-gradient(120deg, rgba(255, 149, 24, 0.9), rgba(255,149,24,0.4))
    touch-action: none

  .pin-badge
    background-color: black
    width: 100%
    height: 100%
</style>
